import React from 'react';

export interface LoadingSplashProps {
  isVisible: boolean;
  text?: string;
  spinnerColor?: string;
  backgroundColor?: string;
  textColor?: string;
  spinnerSize?: string;
  borderRadius?: string;
}

const LoadingSplash: React.FC<LoadingSplashProps> = ({
  isVisible,
  text = 'Loading...',
  spinnerColor = '#865CD0',
  backgroundColor = 'rgba(255, 255, 255, 0.95)',
  textColor = '#865CD0',
  spinnerSize = '40px',
  borderRadius = '10px',
}) => {
  if (!isVisible) return null;

  return (
    <>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: backgroundColor,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: borderRadius,
          zIndex: 1000,
          gap: '12px',
        }}
      >
        <div
          className="loading-spinner"
          style={{
            width: spinnerSize,
            height: spinnerSize,
            border: '4px solid #f3f3f3',
            borderTop: `4px solid ${spinnerColor}`,
            borderRadius: '50%',
          }}
        />
        {text && (
          <p
            style={{
              color: textColor,
              fontWeight: 500,
              fontSize: '14px',
              margin: 0,
            }}
          >
            {text}
          </p>
        )}
      </div>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          .loading-spinner {
            animation: spin 1s linear infinite;
          }
        `}
      </style>
    </>
  );
};

export default LoadingSplash;
